import http from "../axios/http-common";

class InterfaceLogin {
  postLogin(username, pass) {
    return http.postData(`/login`, {
      username: username,
      password: pass
    });
  }
}

export default new InterfaceLogin();
